import React, { Component } from "react";
import { Rating } from "react-simple-star-rating";
import { Product } from "../../Contexts/Contexts";
import ItemCount from "../global/itemCount";
import PulseLoader from "react-spinners/PulseLoader";
import { Link, withRouter } from "routerCompat";
class Vendor extends Component {
  state = {
    addedToCart: false,
    count: 1,
    loading: false,
    minPerOrder: 0,
  };
  componentDidMount() {
    //   check if this product is already in shopping cart
    this.context.shoppingCart?.products?.map((item) => {
      if (item.vendor_item_id === this.props.vendor.vendor_item_id) {
        this.setState({
          addedToCart: true,
          count: item.count,
          maxOrder: item.max_per_order,
          minPerOrder: item.min_per_order,
        });
      } else if (this.context.product.is_tire) {
        this.setState({ count: 2 });
      }
    });
  }
  handleAddToCart = () => {
    this.setState({ loading: true }, () => {
      this.context
        .addToCart({
          count: this.state.count,
          itemId: this.props.vendor.vendor_item_id,
          installNeed: 0,
        })
        .then(() => {
          if (!this.state.addedToCart) {
            this.setState({ addedToCart: true });
          }
          this.context.getShoppingCart();
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    });
  };
  changeCount = (type) => {
    const { stock } = this.context.product;
    const { count } = this.state;
    switch (type) {
      case "add":
        if (stock > count) {
          this.setState({ count: count + 1 }, () => {
            this.handleAddToCart();
          });
        }
        break;
      case "subtract":
        if (count > 2 && this.context.product.is_tire) {
          this.setState({ count: count - 1 }, () => {
            this.handleAddToCart();
          });
        } else if (count > 1 && !this.context.product.is_tire) {
          this.setState({ count: count - 1 }, () => {
            this.handleAddToCart();
          });
        }
        break;
      case "remove":
        this.context
          .removeFromCart(this.props.vendor.vendor_item_id)
          .then(() => {
            this.setState({ addedToCart: false });
            this.context.getShoppingCart();
          });
        break;
      default:
        return;
    }
  };
  installments = () => {
    this.props.history.push({
      pathname: "/Installments",
      state: {
        vendor_item_id: this.props.vendor.vendor_item_id,
        condition: this.props.vendor.condition,
        vendor_id: this.props.vendor.vendor_id,
      },
    });
  };
  submit = () => {
    if (this.props.vendor.need_install) {
      this.context.changeSelectedVendor(this.props.vendor);
      this.context.handleAddToCardModal(true);
    } else {
      this.handleAddToCart();
    }
  };
  render() {
    const {
      store_name,
      guaranty_month,
      system_rate,
      customer_rate,
      price,
      is_installment,
      time_to_ready,
      city_match,
      need_install,
      force_install,
    } = this.props.vendor;
    const { is_tire } = this.context.product;
    const { count } = this.state;

    return (
      <div className="vendorsDetails">
        <div className="vendorP1">
          <img
            className="vendorsNameLogo"
            src="/public/assets/icons/store_1_.svg"
            alt="pic"
          />
          <div className="vendorsName">
            <Link
              to={`/vendor/${this.props.vendor.vendor_id}/3`}
              className="name"
            >
              {store_name}
            </Link>
            <span className="warranty">
              مدت گارانتی : {guaranty_month}
              ماه
            </span>
            <span className="warranty">
              مدت زمان تامین کالا : {time_to_ready} روز
            </span>
          </div>
          <img
            className="vendorsNameLogo tag"
            src="/public/assets/icons/warning-2.svg"
            onClick={this.handleVendorInfoToast}
            alt="pic"
          />
        </div>
        <div className="vendorP1 vendorP2">
          <div className="KacharsRate">
            <span className="titleRate">رتبه کاچار به فروشنده</span>
            <span className="ratingStar">
              <Rating ratingValue={system_rate * 10} readonly={true} />
            </span>
          </div>
          <div className="KacharsRate CustomersRate">
            <span className="titleRate">میانگین رتبه مشتریان </span>
            <span className="ratingStar">
              <Rating ratingValue={customer_rate * 20} readonly={true} />
            </span>
          </div>
        </div>
        <div className="vendorP1 vendorP3">
          <div className="titleRateToman">
            <span className="titleRatePrice">قیمت :</span>
            {price?.toLocaleString() || ""} تومان
          </div>
          {this.state.addedToCart && this.props.vendor.has_install === 0 ? (
            <ItemCount
              data={{
                isTire: is_tire,
                count,
                maxOrder: this.state.maxOrder,
                minPerOrder: this.state.minPerOrder,
              }}
              methods={{
                increase: () => {
                  this.changeCount("add");
                },
                decrease: () => {
                  this.changeCount("subtract");
                },
                removeFromCart: () => {
                  this.changeCount("remove");
                },
              }}
            />
          ) : city_match === 1 ? (
            <button className="apply_filters" onClick={this.submit}>
              {this.state.loading ? (
                <PulseLoader color="#fff" size={10} />
              ) : (
                "              افزودن به سبد خرید"
              )}
            </button>
          ) : need_install && !force_install ? (
            <button className="apply_filters" onClick={this.submit}>
              {this.state.loading ? (
                <PulseLoader color="#fff" size={10} />
              ) : (
                "              افزودن به سبد خرید"
              )}
            </button>
          ) : (
            <span className="disabledVendor">
              این فروشگاه برای شهر شما غیر فعال است
            </span>
          )}
        </div>
        {is_installment === 1 && (
          <div className="installmentItem">
            <div className="installment" onClick={this.installments}>
              خرید اقساطی
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Vendor);

Vendor.contextType = Product;
